import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RoleProvider } from "../context/roleContext";
import { getProfileData } from "../features/profile-management/getProfileDataSlice";
import Header from "./Header";
import HeaderChatBox from "./HeaderChatBox";
import Sidebar from "./Sidebar";

const AppWrapper = ({ children, isSidebarShow }) => {
  let dispatch = useDispatch();
  const {
    loginData= null,
  } = useSelector((state) => ({
    loginData:state.getProfileDataReducer.permissionData
  }));
  /* console.log("loginData",loginData) */
  useEffect(() => {
    /*  let isAuthenticated = getSession(); */
    /*  if (isAuthenticated) { */
    /* Socket.makeConnection(); */
    /*  } */
  }, []);
  const [isToggel, setIsToggle] = useState(false);
  let projectData = JSON.parse(localStorage.getItem("_user"));
  const getCurrentUser = () => {
		dispatch(getProfileData(projectData?.organizations[0].uuid));
	};
  return (
    <RoleProvider value={{ getCurrentUser: getCurrentUser, loginUserData: loginData}}>
    <div
      className={`main-wrapper ${
        isToggel === true ? "dashbord-collapsed" : ""
      }`}
    >
      <div className="cmn-dashbord">
        {isSidebarShow !== false && <Sidebar />}
        {isSidebarShow !== false ? (
          <Header setIsToggle={setIsToggle} isToggel={isToggel} />
        ) : (
          <HeaderChatBox />
        )}
        {children}
      </div>
    </div>
    </RoleProvider>
  );
};

export default AppWrapper;
